import request from '@/utils/http';

// 通知信息分页查询接口
export const queryNotifyInfo = data => {
    return request({
        url: '/api-ntp/ntp/notify-info/queryPage',
        method: 'post',
        data: data
    });
};

/**
 * 记录阅读通知
 */
export const readNotify = data => {
    return request({
        url: '/api-ntp/ntp/notify-info-read/readNotify',
        method: 'post',
        data,
    })
}

// 通知信息创建/修改接口
export const createOrUpdateNotifyInfo = data => {
    return request({
        url: '/api-ntp/ntp/notify-info/createOrUpdate',
        method: 'post',
        data: data
    });
};

// 费用清单审核接口
export const auditNotifyInfo = data => {
    return request({
        url: '/api-ntp/ntp/notify-info/audit',
        method: 'post',
        data: data
    });
};

// 货主管理分页查询
export const baseAnhzInfoList = data => {
    return request({
        url: '/api-ntp/ntp/baseAnhzInfo/list',
        method: 'post',
        data: data
    });
};

export const ossUpload = (data, params, onUploadProgress = () => {}) => {
    const formData = new FormData();
    formData.append('file', data);
    formData.append('bucket', params.bucket);
    formData.append('businessKey', params.businessKey);
    formData.append('publicRead', params.publicRead);
    params.contentType && formData.append('contentType', params.contentType);
    return request({
        url: '/api-oss/oss/file/v2/upload',
        method: 'post',
        data: formData,
        onUploadProgress
    });
};
